import { useClientQuery } from "web_myplann/Api/Client/useClientQuery";
import type { ProfileOverview } from "web_myplann/Profile/Types/ProfileOverview";
import { formatProfileAddress } from "web_myplann/Profile/Utils/formatProfileAddress";
import { formatProfileFullName } from "web_myplann/Profile/Utils/formatProfileFullName";
import { formatProfileName } from "web_myplann/Profile/Utils/formatProfileName";
import { dateFormatter } from "web_myplann/Shared/Utils/dateFormatters";

export const useProfileOverview = () => {
	const { data: userData, isLoading } = useClientQuery();

	const data = userData?.data;
	const clientNotFound = !isLoading && !data;

	const profile: ProfileOverview = {
		name: formatProfileFullName(data),
		displayName: formatProfileName(data),
		email: userData?.contactEmail ?? "",
		phone: userData?.contactPhone ?? "",
		address: formatProfileAddress(userData?.addresses?.[0]),
		birthDate: data?.bornDate ? dateFormatter(data.bornDate) : "",
		photo: userData?.photo ?? undefined,
	};

	return { isLoading, clientNotFound, profile };
};
